<template>
    <section class="form-section">
        <div class="form-section-header flex justify-between items-center">
            <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Representantes FATCA'" :TipoCliente="'Fundos'" :Sessao="'FATCA'" :SubSessao="'Representantes FATCA'"/>
            <button v-if="listaRepresentantes.length > 0" class="btn-primary" @click="incluirPessoa">
                + Adicionar
            </button>
        </div>
        
        <div class="form-section-content">
            <div v-if="listaRepresentantes.length == 0" class="flex flex-col items-center justify-center py-12 px-4">
                <img src="@/assets/addRepresentante.png" class="w-12 h-12 mb-4" />
                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Nenhum representante adicionado</h3>
                <p class="text-sm text-gray-600 dark:text-gray-400 mb-6 text-center">Você pode adicionar mais de um tipo e quantos representantes desejar</p>
                <button class="btn-primary" @click="incluirPessoa">+ Adicionar</button>
            </div>
            
            <div v-if="listaRepresentantes.length > 0" class="border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden">
                <table class="w-full">
                    <thead class="bg-gray-50 dark:bg-slate-800">
                        <tr>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Nome</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">CPF/CNPJ</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">% Participação Societária</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Documento de identidade</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Ações</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700">
                        <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index" class="hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors">
                            <td class="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">{{representanteObj.Nome}}</td>
                            <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">{{formatCpfCnpj(representanteObj.CpfCnpj)}}</td>
                            <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">{{representanteObj.Percentual}}%</td>
                            <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">{{representanteObj.Documento}}</td>
                            <td class="px-4 py-3 text-sm">
                                <div class="flex gap-2">
                                    <button @click.stop.prevent="editarRepresentante(index)" 
                                        class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                                        title="Editar">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button @click.stop.prevent="deletarRepresentante(index)" 
                                        class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                                        title="Excluir">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <ModalAddRepresentanteFatca />
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalAddRepresentanteFatca from './ModalAddRepresentanteFatca.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';
import api from '@/api/axios';

export default {
    name: 'RepresentanteFatca',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
    components: { ModalAddRepresentanteFatca, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_REPRESENTANTES_FI'
        }),
    },
    data() {
      return {

      };
    },
    created(){
       this.$store.dispatch('FETCH_FI_LISTA_REPRESENTANTES');
    },
    mounted(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', false);
    },
    methods: {
      proximaEtapa(){
        this.$store.commit('SET_ETAPA_CADASTRO', 2);
        this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
        this.salvarInformacoes();
      },
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      incluirPessoa(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', true);
      },
      editarRepresentante(index)
      {
        this.$store.commit('SET_MODAL_PJ_EDITAR_PESSOA', this.listaRepresentantes[index]);
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', true);
      },
      async deletarRepresentante(index){
             this.disableBtn = true;
              

                await  api.get(`fundo/facta/excluir?guid=${this.listaRepresentantes[index].Guid}`)
                    .then((retorno) => {
                          
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: 'Exclusão realizada com sucesso!',
                              text: 'Dados informados foram excluídos com sucesso.',
                          });

                          this.$store.dispatch('FETCH_FI_LISTA_REPRESENTANTES');

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }

    }
}

</script>

<style lang="scss" scoped>
</style>